export default (function (file, callback) {
  var reader = new FileReader();

  reader.onloadend = function () {
    callback(reader.result);
  };

  reader.readAsDataURL(file);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/previewFile.js
// module id = 560
// module chunks = 0